import React, {useEffect} from 'react'
import {UIGameVote} from './UIGameVote'
import {useUIGlobalContext} from '@colonist/ui'
import {useGameStore} from '../../store/GameStoreContext'

export interface UIGameVoteProps {
    className?: string
    setLogVisible?: (isVisible: boolean) => void
    setChatVisible?: (isVisible: boolean) => void
}

export const UIGameVoteContainer = ({className, setLogVisible, setChatVisible}: UIGameVoteProps) => {
    const {isUserOnMobile} = useUIGlobalContext()
    const voteState = useGameStore((state) => state.gameVote.voteState)
    const setVoteState = useGameStore((state) => state.gameVote.setVoteState)
    const onVoteAccept = useGameStore((state) => state.gameVote.onVoteAccept)
    const onVoteReject = useGameStore((state) => state.gameVote.onVoteReject)
    const myColor = useGameStore((state) => state.myColor)

    const hideVote = () => {
        if(!voteState) return
        const isMyColorAccepted = voteState.acceptedVotes.includes(myColor)
        const isMyColorDeclined = voteState.declinedVotes.includes(myColor)
        const isMyColorVoted = isMyColorAccepted || isMyColorDeclined
        if(!isMyColorVoted) {
            onVoteReject(voteState.id)
        }
        setVoteState(undefined)
    }

    useEffect(() => {
        if(voteState) {
            setLogVisible?.(false)
            if(isUserOnMobile) setChatVisible?.(false)
        } else {
            setLogVisible?.(true)
            setChatVisible?.(true)
        }
    }, [voteState])

    if(!voteState) return null

    return (
        <UIGameVote
            onHideVote={hideVote}
            onVoteAccept={onVoteAccept}
            onVoteReject={onVoteReject}
            voteState={voteState}
            className={className}/>
    )
}
